import { feedItems } from "@/mocks/communityData";

const hueBg: Record<string, string> = {
  primary: "bg-primary-500",
  secondary: "bg-secondary-500",
  accent: "bg-accent-500",
};

export default function Feed() {
  const [featured, ...rest] = feedItems;

  return (
    <section id="feed" aria-label="最新爆料与精彩讨论" className="w-full bg-background-50 py-16 md:py-24">
      <div className="container-x">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="tag-primary"><i className="ri-chat-new-line"></i>Fresh & Hot</span>
            <h2 className="mt-3 text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              精彩讨论<span className="text-primary-500">正热播</span>
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              话题一上线就停不下来。下面是吧友们此刻正在刷屏的内容，划走之前，记得留下你的看法。
            </p>
          </div>
          <a href="#plaza" className="btn-ghost shrink-0 self-start md:self-auto">
            查看全部版块 <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>

        <div className="mt-9 grid gap-5 lg:grid-cols-2">
          {/* featured */}
          <article className="card relative col-span-1 overflow-hidden p-6 transition-all duration-300 hover:-translate-y-1 hover:ring-2 hover:ring-primary-200 lg:col-span-2 lg:flex lg:gap-6 lg:p-7">
            <div className="lg:w-3/5">
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                  <i className="ri-fire-fill"></i> 本区置顶
                </span>
                <span className="chip">{featured.board}</span>
              </div>
              <h3 className="mt-3 text-lg font-black leading-snug text-foreground-950 md:text-xl">{featured.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
              <div className="mt-5 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                <span className={"flex h-8 w-8 items-center justify-center rounded-full text-background-50 " + (hueBg[featured.avatarHue] || "bg-primary-500")}>
                  {featured.author[0]}
                </span>
                <span className="font-semibold text-foreground-800">{featured.author}</span>
                <span className="flex items-center gap-1"><i className="ri-time-line"></i>{featured.time}</span>
                <span className="ml-auto flex items-center gap-3">
                  <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i>{featured.likes}</span>
                  <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i>{featured.comments}</span>
                </span>
              </div>
              <a href="#plaza" className="btn-primary mt-6">
                去围观讨论 <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </div>
            <img
              src="https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20fun%20lively%20online%20discussion%20around%20a%20new%20music%20single%2C%20headphones%20and%20musical%20notes%20and%20debate%20speech%20bubbles%20with%20thumbs%20up%20and%20down%2C%20cream%20ivory%20background%20with%20coral%20red%20leaf%20green%20and%20amber%20accents%2C%20playful%20modern%20editorial%20art%2C%20soft%20shadows%2C%20balanced%20clean%20composition&width=700&height=520&seq=feed-featured&orientation=portrait"
              alt="热门音乐话题引发的网友激烈讨论插画"
              className="mt-5 h-52 w-full rounded-xl object-cover object-top lg:mt-0 lg:h-auto lg:w-2/5"
            />
          </article>

          {/* list */}
          {rest.map((item) => (
            <article
              key={item.id}
              className="card group cursor-pointer p-5 transition-all duration-300 hover:-translate-y-1 hover:ring-2 hover:ring-secondary-200 md:p-6"
            >
              <div className="flex items-center gap-2">
                <span className={"flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold text-background-50 " + (hueBg[item.avatarHue] || "bg-primary-500")}>
                  {item.author[0]}
                </span>
                <div className="min-w-0">
                  <p className="truncate text-xs font-semibold text-foreground-800">{item.author}</p>
                  <p className="flex items-center gap-1 text-[11px] text-foreground-400"><i className="ri-time-line"></i>{item.time}</p>
                </div>
                <span className="ml-auto whitespace-nowrap rounded-full bg-background-100 px-2.5 py-1 text-[11px] font-semibold text-secondary-800">
                  {item.board}
                </span>
              </div>
              <h3 className="mt-3 text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                {item.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{item.summary}</p>
              <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex cursor-pointer items-center gap-1 transition-colors hover:text-primary-600"><i className="ri-thumb-up-line"></i>{item.likes}</span>
                <span className="flex cursor-pointer items-center gap-1 transition-colors hover:text-primary-600"><i className="ri-chat-1-line"></i>{item.comments}</span>
                <span className="ml-auto flex cursor-pointer items-center gap-1 font-semibold text-primary-700 transition-transform group-hover:translate-x-1">
                  展开聊 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}